/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Filter_Search_In_TitleInputs */

const cs_blog_filter_search_in_title = /** @type {(inputs: Blog_Filter_Search_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název`)
};

const en_blog_filter_search_in_title = /** @type {(inputs: Blog_Filter_Search_In_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title`)
};

/**
* | output |
* | --- |
* | "Title" |
*
* @param {Blog_Filter_Search_In_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_filter_search_in_title = /** @type {((inputs?: Blog_Filter_Search_In_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Filter_Search_In_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_filter_search_in_title(inputs)
	return cs_blog_filter_search_in_title(inputs)
});